export default __webpack_public_path__ + "static/media/Mastercard.adacc204.svg";